<script lang="ts">import { cfgToThemeCdnPath } from "@infinitro/config";
import { isMobile, loggedIn } from "@infinitro/global";
import { campaignHeroPromoCards } from "./data/campaign-hero";
import BigCardPlayer from "./parts/top-section-campaign-hero/big-card-player.svelte";
import ContentPanel from "./parts/top-section-campaign-hero/content-panel.svelte";
import PromoCard from "./parts/top-section-campaign-hero/promo-card.svelte";
const DESKTOP_HERO_WIDTH = 1200;
const backgroundImage = cfgToThemeCdnPath("/top-section/campaign-hero/background.png");
let availableWidth = 0;
let unscaledHeight = 0;
$: heroWidth = $isMobile ? "100%" : `${DESKTOP_HERO_WIDTH}px`;
$: scale = $isMobile || availableWidth <= 0 ? 1 : Math.min(availableWidth / DESKTOP_HERO_WIDTH, 1);
$: scaledHeight = unscaledHeight * scale;
</script>

<div
	class="campaign-hero-wrapper"
	bind:clientWidth={availableWidth}
	style:height={`${scaledHeight}px`}
>
	<div
		class="top-section-campaign-hero"
		style:width={heroWidth}
		style:transform={`scale(${scale})`}
		bind:clientHeight={unscaledHeight}
	>
		<img class="campaign-background" src={backgroundImage} alt="" />
		<div class="content-panel-container" class:content-panel-container-player={$loggedIn}>
			{#if $loggedIn}
				<BigCardPlayer rankIconSizeMobile={90} rankIconSizeDesktop={160} />
			{:else}
				<ContentPanel />
			{/if}
		</div>
		<div class="promo-cards-container">
			{#each campaignHeroPromoCards as card (card.linkUrl)}
				<PromoCard
					title={card.title}
					icon={card.icon}
					borderColor={card.borderColor}
					backgroundImage={card.backgroundImage}
					linkUrl={card.linkUrl}
				/>
			{/each}
		</div>
	</div>
</div>

<style>
	.campaign-hero-wrapper {
		width: 100%;
}

	.top-section-campaign-hero {
		position: relative;
		isolation: isolate;
		display: flex;
		width: 100%;
		flex-direction: column;
		gap: 1rem;
		transform-origin: top left;
}

	.campaign-background {
		pointer-events: none;
		position: absolute;
		z-index: 0;
		--tw-translate-x: -50%;
		--tw-translate-y: -50%;
		transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
		top: 27%;
		left: 70%;
		max-width: 200px;
}

	.content-panel-container {
		position: relative;
		z-index: 10;
		width: 100%;
}

	.content-panel-container-player {
		height: 210px;
	}

	:global(.content-panel-container-player .big-card-player) {
		height: 100%;
		min-height: 0;
		aspect-ratio: auto;
	}

	.promo-cards-container {
		position: relative;
		z-index: 10;
		display: flex;
		width: 100%;
		gap: 0.75rem;
}

	@media (min-width: 640px) {
		.content-panel-container-player {
			height: 240px;
		}
	}

	@media (min-width: 1024px) {
		.top-section-campaign-hero {
				flex-direction: row;
				align-items: center;
				gap: 1rem;
		}

		.campaign-background {
			left: 37%;
			top: 65%;
			max-width: none;
		}

		.content-panel-container {
			width: 50%;
		}

		.content-panel-container-player {
			height: 240px;
		}

		.promo-cards-container {
				gap: 1rem;
			width: 50%;
		}
	}
</style>
